/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoMangimiDettaglioUpdateDTO
 */
export interface ListinoMangimiDettaglioUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioUpdateDTO
     */
    idTipoMangime?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoMangimiDettaglioUpdateDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioUpdateDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the ListinoMangimiDettaglioUpdateDTO interface.
 */
export function instanceOfListinoMangimiDettaglioUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoMangimiDettaglioUpdateDTOFromJSON(json: any): ListinoMangimiDettaglioUpdateDTO {
    return ListinoMangimiDettaglioUpdateDTOFromJSONTyped(json, false);
}

export function ListinoMangimiDettaglioUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoMangimiDettaglioUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoMangime': !exists(json, 'idTipoMangime') ? undefined : json['idTipoMangime'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ListinoMangimiDettaglioUpdateDTOToJSON(value?: ListinoMangimiDettaglioUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoMangime': value.idTipoMangime,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
    };
}

